import CategoriesTab from "./categories-tab/CategoriesTab";

const TABS = {
	CategoriesTab,
};

export default TABS;
